import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { trackByIndex } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { FontSize, FontSizeMap } from '@core/prosemirror-legacy';
import {
  DropdownComponent,
  DropdownItemComponent,
  DropdownWidth,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-size-menu',
  templateUrl: './size-menu.component.html',
  styleUrl: './size-menu.component.less',
  imports: [CommonModule, DropdownComponent, DropdownItemComponent, TranslatePipe],
})
export class SizeMenuComponent {
  protected readonly DropdownWidth = DropdownWidth;
  protected readonly trackByIndex = trackByIndex;

  public readonly labels: Record<FontSize, string> = {
    [FontSize.Small]: 'wysiwyg.font_size.small',
    [FontSize.Normal]: 'wysiwyg.font_size.normal',
    [FontSize.Medium]: 'wysiwyg.font_size.medium',
    [FontSize.Large]: 'wysiwyg.font_size.large',
    [FontSize.XLarge]: 'wysiwyg.font_size.x_large',
  };
  public readonly options = [
    ...Object.values(FontSize).map((key: FontSize) => ({
      label: this.labels[key],
      value: FontSizeMap[key],
    })),
  ];

  public select: (val: string) => void;
  public close: () => void;
  public getActiveVal: () => string | null;

  public isActive(value: string) {
    return (this.getActiveVal() || '') === value;
  }
}
